module.exports = __webpack_public_path__ + "img/bg-work.e8783d74.jpg";